module.exports = __webpack_public_path__ + "img/splash_screen_banner_app.66a759ef.png";